if(!customElements.get('offers-slider')) {
  customElements.define(
    'offers-slider',
    class SpecialOffers extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) return console.log("Can't initialize offers slider without a slider element.");

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1,
          spaceBetween: 10,
          breakpoints: {
            768: {
              spaceBetween: 16
            }
          },
          navigation: {
            prevEl: ".offers-slider-button.prev",
            nextEl: ".offers-slider-button.next",
          },
          pagination: {
            el: ".offers-slider-pagination",
            type: "bullets",
            clickable: true
          }
        });
      }
    }
  );
}